module.exports = __webpack_public_path__ + "img/fondo-pefil.49eb49f9.png";